import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  IconButton,
  Typography,
  Container,
  AppBar,
  Toolbar,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const SearchPage: React.FC = () => {
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();

  // Auto-focus the input when component mounts
  useEffect(() => {
    const input = document.querySelector(
      'input[type="text"]'
    ) as HTMLInputElement;
    if (input) {
      input.focus();
    }
  }, []);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const handleSearchSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchValue.trim()) {
      navigate(
        `/research-and-articles?search=${encodeURIComponent(
          searchValue.trim()
        )}`
      );
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Escape") {
      handleBack();
    }
  };

  return (
    <Box sx={{ height: "100vh", bgcolor: "rgba(41, 80, 92, 0.98)" }}>
      <AppBar
        position="static"
        sx={{
          bgcolor: "#295052",
          boxShadow: "none",
          borderBottom: "1px solid rgba(255,255,255,0.1)",
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleBack}
            sx={{ color: "#fff" }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" sx={{ color: "#fff", fontWeight: 500 }}>
            Search Articles
          </Typography>
          <Box sx={{ width: 48 }} /> {/* Spacer for centering */}
        </Toolbar>
      </AppBar>

      <Container maxWidth="sm" sx={{ pt: 4, px: 3 }}>
        <Box
          component="form"
          onSubmit={handleSearchSubmit}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
            alignItems: "center",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              color: "#fff",
              textAlign: "center",
              mb: 2,
              fontWeight: 300,
            }}
          >
            Find articles by tags
          </Typography>

          <Box
            sx={{
              display: "flex",
              width: "100%",
              bgcolor: "#fff",
              borderRadius: 2,
              overflow: "hidden",
              boxShadow: 3,
            }}
          >
            <TextField
              autoFocus
              fullWidth
              placeholder="Search..."
              value={searchValue}
              onChange={handleSearchChange}
              onKeyDown={handleKeyDown}
              variant="standard"
              InputProps={{
                disableUnderline: true,
                sx: {
                  fontSize: 18,
                  px: 3,
                  py: 2,
                },
              }}
            />
            <IconButton
              type="submit"
              disabled={!searchValue.trim()}
              sx={{
                bgcolor: "#20414a",
                color: "#fff",
                borderRadius: 0,
                height: 67,
                width: 67,
                "&:hover": { bgcolor: "#1976d2" },
                "&.Mui-disabled": {
                  bgcolor: "rgba(33, 63, 72, 0.98)",
                  color: "#fff",
                },
              }}
            >
              <SearchIcon sx={{ fontSize: 28 }} />
            </IconButton>
          </Box>

          <Typography
            variant="body2"
            sx={{
              color: "rgba(255,255,255,0.7)",
              textAlign: "center",
              // maxWidth: 300,
            }}
          >
            Search through article tags to find relevant content
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default SearchPage;
